export default {
  modalTitle: 'Create eCourier Logistics Order',
  content1: 'Recipient name',
  content2: 'Recipient Phone',
  content3: 'Division',
  content4: 'District or City (eCourier)',
  content5: 'Area (eCourier)',
  content6: 'Recipient Address',
  content7: 'eCourier Package Code',
  content8: 'Package Amount',
  content9: 'Payment Method',
  content10: 'Product ID',
  content11: 'Comments',
  content12: 'eCourier Number',
  content13: 'eCourier NO. Creation Failed',
  content14: 'Confirm to submitted manually',
  placeholder1: 'Enter eCourier Number if submitted manually',
  eCourierCode1: 'Pending Creation',
  buttonContent1: 'Submit',
  buttonContent2: 'Loading…',
  warning1: 'Please enter eCourier Number.',
  warning2: 'The information is incomplete.',
  warning3: 'Processing, please try again later.',
  open1: 'eCourier Number Creation Failed',
  cod: 'COD'
}
